import {Record as record, Set as set} from 'immutable';
import PropTypes from 'prop-types';
import _ from 'lodash';

import MomentPropTypes from '../../helpers/MomentPropTypes';
import {construct, fields, resolve} from '../../helpers/LinkMapper';
import {serialize, serializers, deserialize, deserializers} from '../../helpers/SearchUrls';
import trainTime from '../../lib/TrainTime';

import SearchMixin from '../SearchMixin';
import Station from '../Station';

export const SmartCarnetSearchRecordShape = PropTypes.shape({
    destination: PropTypes.instanceOf(Station).isRequired,
    origin: PropTypes.instanceOf(Station).isRequired,
    startingDate: MomentPropTypes.isTrainTime.isRequired,
});

const defaults = {
    destination: new Station(),
    origin: new Station(),
    startingDate: trainTime(),
    adults: 1,
};

export class SmartCarnetRecordSearch extends record(defaults) {
    static fromJSON(json = {}) {
        json = _.defaults(json, {adults: 0});
        return construct(SmartCarnetRecordSearch, json, {
            destination: resolve.as(Station),
            origin: resolve.as(Station),
            startingDate: fields.datetime,
            adults: fields.number,
        });
    }
    serialize() {
        return serialize(
            {
                destination: serializers.station,
                origin: serializers.station,
                startingDate: serializers.date,
                adults: serializers.identity,
            },
            this,
        );
    }

    static deserialize(params, query) {
        const source = Object.assign({}, query, params);
        const schema = {
            destination: deserializers.station,
            origin: deserializers.station,
            startingDate: deserializers.date,
        };

        return deserialize(schema, source).then(deserialized => {
            return new SmartCarnetRecordSearch(deserialized);
        });
    }

    getComputedValues() {
        return {
            destination: this.destination.getName(),
            origin: this.origin.getName(),
            startingDate: fields.date,
        };
    }

    validateDatesInFuture() {
        return this.startingDate && this.startingDate.isSameOrAfter(trainTime(), 'day');
    }

    getValidationErrors() {
        const tests = set([
            'validateStationsComplete',
            'validateStationsNotEqual',
            'validateDatesInFuture',
        ]);

        return tests.filterNot(test => this[test]());
    }

    isValid() {
        return this.getValidationErrors().isEmpty();
    }
}

Object.assign(SmartCarnetRecordSearch.prototype, SearchMixin);

export default SmartCarnetRecordSearch;



// WEBPACK FOOTER //
// ./src/records/smartCarnet/SmartCarnetRecordSearch.js